import { artSrc } from '../studio/UI';
import { useEffect, useState } from 'react';

const isBlankStrip = (getLuma, length) => {
    let sum = 0;
    let sumSq = 0;
    for (let i = 0; i < length; i += 1) {
        const luma = getLuma(i);
        sum += luma;
        sumSq += luma * luma;
    }
    const mean = sum / length;
    const variance = Math.max(0, sumSq / length - mean * mean);
    return mean > 214 && Math.sqrt(variance) < 24;
};

const trimWhite = (image) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    canvas.width = image.width;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0);
    const { data, width, height } = ctx.getImageData(0, 0, image.width, image.height);
    const lumaAt = (x, y) => {
        const i = (y * width + x) * 4;
        return 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    };

    const blankRow = row => isBlankStrip(x => lumaAt(x, row), width);
    const blankColumn = column => isBlankStrip(y => lumaAt(column, y), height);
    let top = 0;
    let bottom = height - 1;
    let left = 0;
    let right = width - 1;

    while (top < bottom && blankRow(top)) {
        top += 1;
    }
    while (bottom > top && blankRow(bottom)) {
        bottom -= 1;
    }
    while (left < right && blankColumn(left)) {
        left += 1;
    }
    while (right > left && blankColumn(right)) {
        right -= 1;
    }

    const pad = Math.round(Math.min(width, height) * 0.012);
    top = Math.max(0, top - pad);
    left = Math.max(0, left - pad);
    bottom = Math.min(height - 1, bottom + pad);
    right = Math.min(width - 1, right + pad);

    const cropW = Math.max(1, right - left + 1);
    const cropH = Math.max(1, bottom - top + 1);
    const cropped = document.createElement('canvas');
    cropped.width = cropW;
    cropped.height = cropH;
    cropped.getContext('2d').drawImage(image, left, top, cropW, cropH, 0, 0, cropW, cropH);
    return cropped.toDataURL('image/webp', 0.86);
};

const TrimmedArtwork = ({ src, alt, imageWidth = 1400 }) => {
    const optimized = artSrc(src);
    const resolvedSrc = optimized.startsWith('/studio-products/') ? `${optimized}?w=${imageWidth}` : optimized;
    const [trimmed, setTrimmed] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setTrimmed(null);
        const image = new Image();
        image.onload = () => {
            if (cancelled) {
                return;
            }
            try {
                setTrimmed(trimWhite(image));
            } catch (error) {
                setTrimmed(resolvedSrc);
            }
        };
        image.onerror = () => {
            if (!cancelled) {
                setTrimmed(resolvedSrc);
            }
        };
        image.src = resolvedSrc;
        return () => {
            cancelled = true;
        };
    }, [resolvedSrc]);

    return (
        <img
            className="productArtwork"
            src={trimmed || resolvedSrc}
            alt={alt}
        />
    );
};

export default TrimmedArtwork;
